module.exports = __webpack_public_path__ + "static/media/infosys.3314523f.jpg";